export const UserRole = {
  CUSTOMER_B2C: 'CUSTOMER_B2C',
  CUSTOMER_B2B: 'CUSTOMER_B2B',
  INTERNAL_EMPLOYEE: 'INTERNAL_EMPLOYEE',
  AGENT: 'AGENT',
  ADMIN: 'ADMIN',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const STAFF_ROLES: UserRole[] = [UserRole.AGENT, UserRole.ADMIN];
export const CUSTOMER_ROLES: UserRole[] = [
  UserRole.CUSTOMER_B2C,
  UserRole.CUSTOMER_B2B,
  UserRole.INTERNAL_EMPLOYEE,
];

export function isStaff(role: UserRole): boolean {
  return STAFF_ROLES.includes(role);
}
